import React from 'react'

function BA_program_details() {
  return (
    <div>

      {/* ---------------------mobile view-------------------- */}
      <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Mastering Business Analytics Brilliance!</h1>
                    <p className='py-2'>"Unlock the secrets of success with our Business Analytics program. Enrol now to harness the power of data and chart your course towards a brilliant future!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity with Python while studying statistics and visualising data. Learn about databases including SQL, NoSQL, and Spark, as well as other data science technologies. Learn to use the essential tools of business analytics and time series forecasting. Proficient in both Excel and web development, with an emphasis on practical experience. Improve your proficiency in everything from data management to strategic analysis to give yourself the best chance of succeeding in the dynamic profession of Business Analytics.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Business Analytics</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
      </div>

      {/* ---------------------Desktop view----------------- */}
      <div className='d-none d-md-block'>
        <div className='container'>
          <div className='row'>
              <div className='col-md-8 detail_1stcomp_img'>
                  <div className='pt-3 Program_details_1stcomp_text'>
                      <h1 className='display-6'>Mastering Business Analytics Brilliance!</h1>
                      <p className='py-4'>"Unlock the secrets of success with our Business Analytics program. Enrol now to harness the power of data and chart your course towards a brilliant future!</p>
                  </div>
                  <div className='mt-3 Program_details_1stcomp_text'>
                      <h1 className='display-3'>Overview</h1>
                      <p className='py-4'>With our in-depth training, you can enter the exciting field of Business Analytics. Gain familiarity with Python while studying statistics and visualising data. Learn about databases including SQL, NoSQL, and Spark, as well as other data science technologies. Learn to use the essential tools of business analytics and time series forecasting. Proficient in both Excel and web development, with an emphasis on practical experience. Improve your proficiency in everything from data management to strategic analysis to give yourself the best chance of succeeding in the dynamic profession of Business Analytics.</p>
                  </div>
              </div>
              <div className='col-md-4'>
                  <div>
                  <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                  <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Business Analytics</h1>
                    <div className='Details_text '>
                      <ul className='pt-4'>
                        <li>Live conversations with industry professionals</li>
                        <li className='py-3'>Project support and Guidance</li>
                        <li>Access to Specialized Course Materials</li>
                        <li className='py-3'>25+ Hours of Learning</li>
                        <li>Certificates from reputable MNC's around the world</li>
                      </ul>
                    </div>
                    <div className='text-center'>
                    {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                    </div>
                  </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BA_program_details
